import { SVGProps } from 'react';

const TextSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 6H3m7 6H3m7 6H3m18 1-1.9-1.9M20 15a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default TextSearch;
